import React, { useEffect } from 'react'
import ProductDetailsRelatedProducts from '../Components/ProductDetails/ProductDetailsRelatedProducts';
import ProductDetailsTop from '../Components/ProductDetails/ProductDetailsTop';
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';

const GetProductDetails = () => {
    return (
        <>
            <ToastContainer />
            <main className="main">
                <div className="page-header breadcrumb-wrap">
                    <div className="container">
                        <div className="breadcrumb">
                            <Link
                                to={"/"}
                                rel="nofollow"
                            >
                                <i className="fi-rs-home mr-5" />
                                Home
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="container mb-30">
                    <div className="row">
                        <div className="col-xl-10 col-lg-12 m-auto">
                            <div className="product-detail accordion-detail">
                                <div className="row mb-50 mt-30">
                                    <ProductDetailsTop />
                                </div>
                                <div className="row mt-60">
                                    <ProductDetailsRelatedProducts />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
        </>
    )
}

export default GetProductDetails;